import Base from 'records/Base';
import FileSaver from 'file-saver';
import {
  JPEG_DOWNLOAD_START,
  JPEG_DOWNLOAD_ERROR,
  JPEG_EXTERNAL_ASYNC_SUCCESS,
} from 'actions/jpeg';

const initialState = new Base({
  loading: false,
  errorMessage: null,
});

const actionsMap = {
  [JPEG_DOWNLOAD_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [JPEG_DOWNLOAD_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [JPEG_EXTERNAL_ASYNC_SUCCESS]: (state, action) => {
    const output = new File([action.data], `${ action.fileName }.jpeg`, { type: 'application/jpeg' });
    FileSaver.saveAs(output);
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  }
};

export default function jpeg(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
